/* assets/bt-usp-band.js (25.09.2026, Design und Umsetzung, Trello Banner Startseite mobil, Meldung Kyan)
   Die USP-Leiste der Startseite (sections/bt-h4-hero-editorial, CSS in bt-startseite.css) laeuft auf dem Telefon
   als Band durch. Wer es antippt oder anfasst, haelt es an. Nach 4 Sekunden ohne Beruehrung laeuft es weiter.
   Ohne dieses Skript laeuft das Band einfach weiter, es gibt keine Abhaengigkeit. */
(function () {
  var band = document.querySelector('.btsf .usps .uspband');
  if (!band || !window.PointerEvent) return;
  var timer = 0;
  var WARTEZEIT = 4000;
  function anhalten(e) {
    if (e.pointerType === 'mouse') return;
    window.clearTimeout(timer);
    band.classList.add('is-pause');
  }
  function weiter(e) {
    if (e.pointerType === 'mouse') return;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { band.classList.remove('is-pause'); }, WARTEZEIT);
  }
  band.addEventListener('pointerdown', anhalten, { passive: true });
  band.addEventListener('pointerup', weiter, { passive: true });
  band.addEventListener('pointercancel', weiter, { passive: true });
})();
